<script>
    import Layout from '../../layouts/main'
    import PageHeader from '@/components/page-header'
    import appConfig from "@/app.config";
        
    export default {
        page: {
            title: "Add Agency",
            meta: [
                {
                name: "description",
                content: appConfig.description,
                },
            ],
        },
        components: { Layout, PageHeader },
        data() {
            return {
                title: "Add Agency",
                items: [
                {
                    text: "Agency",
                    href: "/agencies",
                },
                {
                    text: "Add Agency",
                    active: true,
                },        
                ],


                agency: {
                    id: '',
                    name : '',
                    country_code: 1,
                    email: '',
                    password: '',
                    commission_tv: '',
                    commission_image: '',
                },

                countries: [],

                errors: {},
                
                loading: false,
            };
        },
        mounted() {
            this.fetchCountryCodes();
        },

        methods: {

            numbersOnly(event) {
                let keyCode = event.keyCode;
                if (keyCode < 48 || keyCode > 57) {
                event.preventDefault();
                }
            }, 

            noSpaces(event) {
                let keyCode = event.keyCode;
                if(keyCode == 32) {
                event.preventDefault();
                } else {
                return;
                }
            },

            alphaSpacesOnly(event) {
                let keyCode = event.keyCode;
                if ((keyCode >= 65 && keyCode <= 90) || 
                (keyCode >= 97 && keyCode <= 122) ||               
                (keyCode == 32)) {
                    return;
                } else {
                event.preventDefault();
                }
            },

            getToken() {
                if (localStorage.getItem('medicino_admin')) {
                var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
                if(medicino_admin.token) {
                    this.token = medicino_admin.token;
                } else {
                    this.$swal("", "Failed to fetch token, please login again", "error");
                    this.$router.push({ name: "login" });
                }
                
                } else {
                this.$swal("", "Session expired, please login again", "error");
                this.$router.push({ name: "login" });
                }
            }, 

            fetchCountryCodes() {
                let url = "api/admin/get-countries";         
                this.getToken();
                this.$axios
                .get(url, { headers: { Authorization: "Bearer " + this.token } })
                .then((res) => {
                    var responseData = res.data.data;
                    // console.log(responseData);
                    this.countries = responseData.countries;
                })
                .catch((err) => console.log(err));
            },

            addClinic() {
                this.getToken();
                this.loading = true;
                
                const config = {
                headers: {
                    "Content-type": "multipart/form-data",
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
                };

                let url = "api/admin/addAgency";

                let formData = new FormData();
                formData.append("name", this.agency.name); 
                formData.append("country_code", this.agency.country_code); 
                formData.append("phone", this.agency.phone); 
                formData.append("tv_commission", this.agency.commission_tv); 
                formData.append("image_commission", this.agency.commission_image); 
                formData.append("email", this.agency.email); 
                formData.append("password", this.agency.password); 

                this.$axios
                .post(url, formData, config)
                .then((response) => {
                    if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.clearForm();
                    this.$router.push({ name: 'agencies'});
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            this.errors = error.response.data.message;
                            //console.log(this.errors);
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
            },

            clearForm() {        
                this.agency.name = "";
                this.agency.country_code = "";
                this.agency.phone = "";
                this.agency.commission_image = "";
                this.agency.commission_tv = "";
                this.agency.email = "";
                this.agency.password = "";
                this.errors = {};
            },
        }
    }
</script>

    
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                <div class="card-body">

                    <!----- top button area starts---->
                    <div class="row mb-2">
                        <div class="col-12">
                            <router-link :to="{ name: 'agencies' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                        </div>
                    </div>
                    <!----- top button area ends---->
                    <b-card header-class="bg-transparent border-light" class="border border-light">
                        <form class="form-horizontal" role="form" @submit.prevent="addClinic()">
                            
                            <div class="row">

                                <b-col md="12" lg="6" class="form-group">
                                    <label class="control-label">Name <span class="text-danger">*</span></label>
                                    <b-form-input v-model="agency.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }" maxlength="255"></b-form-input>

                                    <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                        <p class="mb-0">{{ val }}</p>
                                    </div>

                                </b-col>

                                <b-col md="12" lg="6" class="form-group">
                                    <label class="control-label">Phone <span class="text-danger">*</span></label>
                                    <b-input-group>
                                        <b-input-group-prepend>
                                            <select class="form-control" v-model="agency.country_code"  v-bind:class="{ 'is-invalid': Boolean(errors.country_code) }">
                                            <option :value="country.id" v-for="country in countries" :key="country.id">{{country.country_code}}</option>
                                            </select>
                                        </b-input-group-prepend>
                                        <b-form-input v-model="agency.phone"  v-bind:class="{ 'is-invalid': Boolean(errors.phone) }" @keypress="numbersOnly" maxlength="15"></b-form-input>

                                        <div v-for="(val, index) in errors.country_code" :key="index" class="invalid-feedback">
                                            <p class="mb-0">{{ val }}</p>
                                        </div>
                                        <div v-for="(val, index) in errors.phone" :key="index" class="invalid-feedback">
                                            <p class="mb-0">{{ val }}</p>
                                        </div>
                                    </b-input-group>
                                </b-col>

                                <b-col md="12" lg="6" class="form-group">
                                    <label class="control-label">Email <span class="text-danger">*</span></label>
                                    <b-form-input type="text" v-model="agency.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>

                                    <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                                        <p class="mb-0">{{ val }}</p>
                                    </div>
                                </b-col>

                                <b-col md="12" lg="6" class="form-group">
                                    <label class="control-label">Password <span class="text-danger">*</span></label>
                                    <b-form-input type="password" v-model="agency.password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }" @keypress="noSpaces" maxlength="16"></b-form-input>

                                    <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                        <p class="mb-0">{{ val }}</p>
                                    </div>
                                </b-col>

                                <b-col md="12" lg="6" class="form-group">
                                    <label class="control-label">Commission for TV Show <span class="text-danger">*</span></label>
                                    <b-input-group prepend="₹">
                                        <b-form-input type="text" v-model="agency.commission_tv" v-bind:class="{ 'is-invalid': Boolean(errors.commission_tv) }" @keypress="numbersOnly"></b-form-input>
                                    </b-input-group>
                                    <div v-for="(val, index) in errors.commission_tv" :key="index" class="invalid-feedback">
                                        <p class="mb-0">{{ val }}</p>
                                    </div>
                                </b-col>

                                <b-col md="12" lg="6" class="form-group">
                                    <label class="control-label">Commission for Image <span class="text-danger">*</span></label>
                                    <b-input-group prepend="₹">
                                        <b-form-input type="text" v-model="agency.commission_image" v-bind:class="{ 'is-invalid': Boolean(errors.commission_image) }" @keypress="numbersOnly" maxlength="16"></b-form-input>
                                    </b-input-group>
                                    <div v-for="(val, index) in errors.commission_image" :key="index" class="invalid-feedback">
                                        <p class="mb-0">{{ val }}</p>
                                    </div>
                                </b-col>

                            </div>

                            <div class="row mt-3">
                            <div class="12">
                                <div v-if="loading" class="page-loader">
                                    <img src="@/assets/images/preloaderspin.gif"/>
                                </div>
                                <div v-else>
                                    <button class="btn btn-primary me-2" type="submit">Save</button>
                                    <router-link :to="{ name: 'clinics' }" class="btn btn-light">Cancel</router-link>
                                </div>
                            </div>
                            </div>
                        </form>
                    </b-card>
                </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
    .page-loader {
        display: flex;
        align-items: center;
        padding: 10px 0;
    }

    .page-loader img {
        width: 50px;
        height: 50px;
    }
</style>
